import {Accordion, Row, Col} from 'react-bootstrap';

function IminioCondominiumListItem({ listId, condominiumData, children }) {

    const getCategoryIndicator = () => {
      const hasUrgent = condominiumData.has_urgent_intervention;
      const hasPrioritary = condominiumData.has_prioritary_intervention;
      
      if (!hasUrgent && !hasPrioritary) {
        return null;
      }
      
      return (
        <>
          {hasUrgent && (
            <span className="ms-2" style={{
              display: 'inline-block',
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: '#dc3545',
              verticalAlign: 'middle'
            }} title="Intervento Urgente"></span>
          )}
          {hasPrioritary && (
            <span className="ms-2" style={{
              display: 'inline-block',
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: '#0d6efd',
              verticalAlign: 'middle'
            }} title="Intervento Prioritario"></span>
          )}
        </>
      );
    }

    return (
        <>
          <Accordion className="mb-2">
            <Accordion.Item eventKey={condominiumData.id}>
              <Accordion.Header className="iminio-list-item-header" >
                  <Row className="justify-content-start align-items-center width-100">
                  <h6 className="fg-orange-dark me-3 text-7" style={{maxWidth: '10px'}}>{condominiumData.id}</h6>
                      <Col id={`${listId}-name`} xs={5} md={3}>
                          <span>
                            {condominiumData.name}
                            {getCategoryIndicator()}
                          </span>
                      </Col>
                      {/* <Col xs={0}> */}
                          {/* <span className="fg-gray">{condominiumData.email}</span> */}
                      {/* </Col> */}
                  </Row>
              </Accordion.Header>
              <Accordion.Body className="iminio-list-item-body">
                {children}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </>
      );
}

export default IminioCondominiumListItem